module.exports = __webpack_public_path__ + "images/instructor-harpreet-sahota-mobile.webp";